export default __webpack_public_path__ + "static/media/s4_title20b.52021602.png";